import React, { useContext, useEffect } from 'react'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Front from 'components/buy/Engraving/Front'
import Back from 'components/buy/Engraving/Back'
import Summary from 'components/buy/Engraving/Summary'

const Engraving = ({ devices, collectionTitle, handleDeviceSelect }) => {
  return <InnerEngraving devices={devices} collectionTitle={collectionTitle} handleDeviceSelect={handleDeviceSelect} />
}

export default Engraving
const InnerEngraving = ({ devices, collectionTitle, handleDeviceSelect }) => {
  const { engraving, resetEngraving } = useContext(EngravingContext)

  useEffect(() => {
    return () => {
      resetEngraving()
    }
  }, [])

  if (!engraving.front.proceeded)
    return <Front devices={devices} collectionTitle={collectionTitle} handleDeviceSelect={handleDeviceSelect} />
  if (!engraving.back.proceeded) return <Back />
  if (engraving.front.proceeded && engraving.back.proceeded) return <Summary />
}
